const getData = JSON.parse(localStorage.getItem("schedule")) || [];

const schedule = {
  namespaced: true,
  state: {
    scheduleData: getData,
    selScheduleData: null,
  },
  mutations: {
    createSchedule(state, payload) {
      const newData = getData.concat(payload);
      state.scheduleData = newData;
      localStorage.setItem("schedule", JSON.stringify(newData));
    },
    selectSchedule(state, payload) {
      state.selScheduleData = payload;
    },
  },
  actions: {
    SELECT_DATE({ commit }, payload) {
      commit("selectSchedule", payload);
    },
    CREATE_SCHEDULE({ commit }, payload) {
      commit("createSchedule", payload);
    },
  },
};

export default schedule;
